import moment from 'moment'

const comps = {
  toAscii (bin) {
    return bin.replace(/\s*[01]{8}\s*/g, function (bin) {
      return String.fromCharCode(parseInt(bin, 2))
    })
  },
  toBinary (str, spaceSeparatedOctets) {
    return str.replace(/[\s\S]/g, function (str) {
      str = comps.zeroPad(str.charCodeAt().toString(2))
      return !1 === spaceSeparatedOctets ? str : str + ' '
    })
  },
  toHexa (str, spaceSeparatedOctets) {
    return str.replace(/[\s\S]/g, function (str) {
      str = comps.zeroPad(str.charCodeAt().toString(16))
      return !1 === spaceSeparatedOctets ? str : str + ' '
    })
  },
  zeroPad (num) {
    return '00000000'.slice(String(num).length) + num
  },
  diffFromPreviousDate (datesArray, index, units = 'day') { // String, Number, String
    const date1 = moment(datesArray[index])
    const date0 = moment(datesArray[index - 1])
    if (datesArray[index] && datesArray[index - 1] && date1.isValid() && date0.isValid()) {
      // Calculate the difference
      const diff = moment.duration(date1.startOf(units).diff(date0.startOf(units)))
      if (units === 'day') return diff.days()
      else if (units === 'week') return diff.weeks()
      else return undefined
    }
    // If some of the dates in undefined, return undefined
    return undefined
  },
  //   distance (calculates distance based on GPS coordinates)
  //   lat1, lon1 = Latitude and Longitude of point 1 (in decimal degrees)
  //   lat2, lon2 = Latitude and Longitude of point 2 (in decimal degrees)
  //   unit = the unit you desire for results
  //          where: 'M' is statute miles
  //                 'K' is kilometers (default)
  //                 'N' is nautical miles
  distance ({ lat1, lon1, lat2, lon2, unit }) {
    const radlat1 = Math.PI * lat1 / 180
    const radlat2 = Math.PI * lat2 / 180
    const theta = lon1 - lon2
    const radtheta = Math.PI * theta / 180
    let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta)
    if (dist > 1) {
      dist = 1
    }
    dist = Math.acos(dist)
    dist = dist * 180 / Math.PI
    dist = dist * 60 * 1.1515
    if (unit === 'M') {
      dist = dist * 1.000000
    } else if (unit === 'K') {
      dist = dist * 1.609344
    } else if (unit === 'N') {
      dist = dist * 0.8684
    } else {
      // Defaults to K
      dist = dist * 1.609344
    }

    return dist
  }
}

export default comps
